/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageFragmentContainer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 2H2v20h8v-2H4V4h16v6h2V2h-1zm3 4h12v4H6zm8 8h-2v-2h2zm4 0h-2v-2h2zm4-2v2h-2v-2zm-8 6h-2v-2h2zm8-2v2h-2v-2zm-8 6h-2v-2h2zm4 0h-2v-2h2zm-8-10H6v6h4zm12 10h-2v-2h2z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPageFragmentContainer as PageFragmentContainer };
